export const LOCATION_DOCUMENT_DROP_DOWN_ITEMS = []